import { Home, Gamepad2, Backpack, User, Package, TrendingUp, FileText, ShoppingCart, Swords, Crown, CircleDot, Target, Activity, Bomb, Cherry } from 'lucide-react'

export const getNavigationItems = (t) => [
  {
    path: '/',
    icon: Home,
    label: t('nav.home'),
    exact: true
  },
  {
    path: '/games',
    icon: Gamepad2,
    label: t('nav.games')
  },
  {
    path: '/inventory',
    icon: Backpack,
    label: t('nav.inventory')
  },
  {
    path: '/profile',
    icon: User,
    label: t('nav.profile')
  }
]

// Слоты видны только при slot_enabled === true в /api/me/ (ключа нет — режима нет)
export const getGameModeNavigationItems = (t, user) => [
  {
    id: 'cases',
    title: t('games.cases'),
    icon: Package,
    path: '/cases',
    bgGradient: 'from-accent-primary/10 via-surface/60 to-accent-primary/5',
    borderColor: 'border-[rgb(0,110,50)]',
    iconBg: 'bg-accent-primary/20',
    iconBorder: 'border-accent-primary/50',
    textColor: 'text-accent-primary',
    badgeBg: 'bg-accent-primary/30',
    badgeBorder: 'border-accent-primary/50',
    shadowColor: 'shadow-accent-primary/20',
    overlayGradient: 'from-accent-primary/5',
    available: true
  },
  {
    id: 'battles',
    title: t('battle.title'),
    icon: Swords,
    path: '/battles',
    isNew: false,
    bgGradient: 'from-red-500/10 via-surface/60 to-red-500/5',
    borderColor: 'border-[rgb(117,34,25)]',
    iconBg: 'bg-red-500/20',
    iconBorder: 'border-red-500/50',
    textColor: 'text-red-500',
    badgeBg: 'bg-red-500/30',
    badgeBorder: 'border-red-500/50',
    shadowColor: 'shadow-red-500/20',
    overlayGradient: 'from-red-500/5',
    available: true
  },
  {
    id: 'double',
    title: t('double.title', 'Double'),
    icon: CircleDot,
    path: '/double',
    isNew: false,
    bgGradient: 'from-teal-500/10 via-surface/60 to-emerald-500/5',
    borderColor: 'border-[rgb(0,82,141)]',
    iconBg: 'bg-teal-500/20',
    iconBorder: 'border-teal-500/50',
    textColor: 'text-teal-400',
    badgeBg: 'bg-teal-500/30',
    badgeBorder: 'border-teal-500/50',
    shadowColor: 'shadow-teal-500/20',
    overlayGradient: 'from-teal-500/5',
    available: true
  },
  {
    id: 'x50',
    title: t('wheel500.title', 'X50'),
    icon: Target,
    path: '/x50',
    isNew: false,
    bgGradient: 'from-emerald-500/10 via-surface/60 to-amber-500/5',
    borderColor: 'border-[rgb(76,17,138)]',
    iconBg: 'bg-emerald-500/20',
    iconBorder: 'border-emerald-500/50',
    textColor: 'text-emerald-400',
    badgeBg: 'bg-emerald-500/30',
    badgeBorder: 'border-emerald-500/50',
    shadowColor: 'shadow-emerald-500/20',
    overlayGradient: 'from-emerald-500/5',
    available: true
  },
  {
    id: 'upgrader',
    title: t('games.upgrader'),
    icon: TrendingUp,
    path: '/upgrader',
    bgGradient: 'from-blue-500/10 via-surface/60 to-blue-500/5',
    borderColor: 'border-[rgb(40,62,196)]',
    iconBg: 'bg-blue-500/20',
    iconBorder: 'border-blue-500/50',
    textColor: 'text-blue-500',
    badgeBg: 'bg-blue-500/30',
    badgeBorder: 'border-blue-500/50',
    shadowColor: 'shadow-blue-500/20',
    overlayGradient: 'from-blue-500/5',
    available: true
  },
  {
    id: 'contracts',
    title: t('games.contracts'),
    icon: FileText,
    path: '/contract',
    bgGradient: 'from-purple-500/10 via-surface/60 to-purple-500/5',
    borderColor: 'border-[rgb(92,49,134)]',
    iconBg: 'bg-purple-500/20',
    iconBorder: 'border-purple-500/50',
    textColor: 'text-purple-500',
    badgeBg: 'bg-purple-500/30',
    badgeBorder: 'border-purple-500/50',
    shadowColor: 'shadow-purple-500/20',
    overlayGradient: 'from-purple-500/5',
    available: true
  },
  {
    id: 'battleRoyale',
    title: t('games.battleRoyale'),
    icon: Crown,
    path: '/royale',
    isNew: false,
    bgGradient: 'from-yellow-500/10 via-surface/60 to-yellow-500/5',
    borderColor: 'border-[rgb(143,121,23)]',
    iconBg: 'bg-yellow-500/20',
    iconBorder: 'border-yellow-500/50',
    textColor: 'text-yellow-500',
    badgeBg: 'bg-gray-500/20',
    badgeBorder: 'border-gray-500/30',
    shadowColor: 'shadow-yellow-500/20',
    overlayGradient: 'from-yellow-500/5',
    available: true
  },
  {
    id: 'crash',
    title: t('crash.title', 'Crash'),
    icon: Activity,
    path: '/crash',
    bgGradient: 'from-red-500/10 via-surface/60 to-red-500/5',
    borderColor: 'border-red-500/50',
    iconBg: 'bg-red-500/20',
    iconBorder: 'border-red-500/50',
    textColor: 'text-red-500',
    badgeBg: 'bg-gray-500/20',
    badgeBorder: 'border-gray-500/30',
    shadowColor: 'shadow-red-500/20',
    overlayGradient: 'from-red-500/5',
    isNew: false,
    available: true
  },
  {
    id: 'mines',
    title: t('mines.title'),
    icon: Bomb,
    path: '/mines',
    bgGradient: 'from-amber-500/10 via-surface/60 to-amber-500/5',
    borderColor: 'border-[rgb(207,55,9)]',
    iconBg: 'bg-amber-500/20',
    iconBorder: 'border-amber-500/50',
    textColor: 'text-amber-500',
    badgeBg: 'bg-amber-500/30',
    badgeBorder: 'border-amber-500/50',
    shadowColor: 'shadow-amber-500/20',
    overlayGradient: 'from-amber-500/5',
    isNew: false,
    available: true
  },
  {
    id: 'slot',
    title: t('slot.title'),
    icon: Cherry,
    path: '/slot',
    bgGradient: 'from-fuchsia-500/10 via-surface/60 to-fuchsia-500/5',
    borderColor: 'border-[rgb(92,11,161)]',
    iconBg: 'bg-fuchsia-500/20',
    iconBorder: 'border-fuchsia-500/50',
    textColor: 'text-fuchsia-400',
    badgeBg: 'bg-fuchsia-500/30',
    badgeBorder: 'border-fuchsia-500/50',
    shadowColor: 'shadow-fuchsia-500/20',
    overlayGradient: 'from-fuchsia-500/5',
    isNew: true,
    available: true
  },
  {
    id: 'market',
    title: t('market.title'),
    icon: ShoppingCart,
    path: '/market',
    bgGradient: 'from-orange-500/10 via-surface/60 to-orange-500/5',
    borderColor: 'border-[rgb(149,70,0)]',
    iconBg: 'bg-orange-500/20',
    iconBorder: 'border-orange-500/50',
    textColor: 'text-orange-500',
    badgeBg: 'bg-orange-500/30',
    badgeBorder: 'border-orange-500/50',
    shadowColor: 'shadow-orange-500/20',
    overlayGradient: 'from-orange-500/5',
    available: true
  }
].filter((item) => item.id !== 'slot' || user?.slot_enabled === true)

export const getDesktopGameModeNavigationItems = (t, user) => {
  return getGameModeNavigationItems(t, user).filter((item) => item.id !== 'market' && item.available)
}
